import { DatePicker } from 'antd';

const AntdRangePicker = ({ ...props }) => {
  return (
    <DatePicker.RangePicker
      allowClear={false}
      format="DD/MM/YYYY HH:mm"
      cellRender={(current, { type, originNode }) => {
        if (type === 'year' || type === 'month') {
          return (
            <div className={`ant-picker-cell-inner ${type}`}>
              {type === 'year' ? current.year() : current.format('MMM')}
            </div>
          );
        }
        return originNode;
      }}
      showTime
      {...props}
    />
  );
};

export default AntdRangePicker;
